<template>
  <div class="writtenStatus">
    <el-card>
      <p style="margin-bottom: 60px">注意：配置笔试资格，开启后即视为生效，可多选开启。</p>
      <p v-for="item in list" :key="item.id" style="font-size: 16px; margin: 20px 0">
        {{ item.remarks }}
        <el-switch
          v-model="item.status"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-value="1"
          :inactive-value="2"
          style="margin-left: 10px;"
          @change="changeStatus(item)">
        </el-switch>
      </p>
    </el-card>
  </div>
</template>

<script>
import { getListTestConf, updateTestConf } from '@/api/product/written'
export default {
  name: 'WrittenStatus',
  data () {
    return {
      list: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const res = await getListTestConf()
      this.list = res.data
    },
    async changeStatus(item) {
      const res = await updateTestConf({id: item.id, status: item.status})
      this.$message.success('操作成功!')
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.writtenStatus {

}
</style>
